import { cn } from '../../lib/utils'

interface ProgressProps {
  value: number
  max?: number
  'aria-label'?: string
  className?: string
  barClassName?: string
}

function Progress({ value, max = 100, className, barClassName, ...props }: ProgressProps) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100))

  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-label={props['aria-label']}
      className={cn('bg-bg-subtle h-1.5 w-full overflow-hidden rounded-full', className)}
    >
      {/* scaleX rather than width: the fill is the only thing that moves, and
          a transform runs on the compositor instead of relaying out the row it
          sits in. The fill is deliberately square — scaling a radius squashes
          it — and the track's own rounding plus overflow-hidden shapes it. */}
      <div
        className={cn(
          'bg-fg h-full w-full origin-left transition-transform duration-150 ease-out',
          barClassName,
        )}
        style={{ transform: `scaleX(${pct / 100})` }}
      />
    </div>
  )
}

export { Progress, type ProgressProps }
